import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allUsers: [],
  user: {},
  archivedCustomerUsers: [],
  currentCustomerUsers: [],
  selectedCustomerUsers: [],
  userProfile: {},
  newUser: {},
  deleteUser: {},
  quickbooksEngineer: {},
  importNewUser: {},
  toggleModal: false,
  isLoading: false,
  error: [],
  enabledSso: false,
  deletedUser: {},
  currentCustomerUsersLoading: false,
  currentCustomerSecurityUsers: [],
  currentCustomerNetworkingUsers: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = [];
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },

    setErrorNew: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    getQuickBooksEngineerIdStart: (state, action) => {
      state.error = [];
      state.isLoading = true;
      state.quickbooksEngineer = {};
    },
    getAllUsersStart: (state, action) => {
      state.error = [];
      state.isLoading = true;
      state.allUsers = [];
    },
    getUserByCustomerIdStart: (state, action) => {
      state.error = [];
      state.isLoading = true;
      state.archivedCustomerUsers = [];
    },
    getUserByCurrentCustomerIdStart: (state, action) => {
      state.error = [];
      // state.isLoading = true;
      state.currentCustomerUsersLoading = true;
      state.currentCustomerUsers = [];
    },
    getUserByCurrentCustomerIdStop: (state, action) => {
      state.currentCustomerUsersLoading = false;
    },
    getUserBySelectedCustomerIdStart: (state, action) => {
      state.error = [];
      state.isLoading = true;
      state.selectedCustomerUsers = [];
    },
    setCurrentCustomerUsers: (state, action) => {
      state.currentCustomerUsers = action.payload;
      // state.isLoading = false;
      state.currentCustomerUsersLoading = false;
      state.error = [];
    },
    setSelectedCustomerUsers: (state, action) => {
      state.selectedCustomerUsers = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllUsers: (state, action) => {
      state.allUsers = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setQuickBooksEngineer: (state, action) => {
      state.quickbooksEngineer = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setArchivedCustomerUsers: (state, action) => {
      state.archivedCustomerUsers = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setNewUser: (state, action) => {
      state.newUser = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setImportNewUser: (state, action) => {
      state.importNewUser = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDeletedUser: (state, action) => {
      state.deletedUser = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setToggleModal: (state, action) => {
      state.toggleModal = !state.toggleModal;
    },
    setCurrentCustomerSecurityUsers: (state, action) => {
      state.currentCustomerSecurityUsers = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentCustomerNetworkingUsers: (state, action) => {
      state.currentCustomerNetworkingUsers = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setResetUser: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setErrorNew,
  getQuickBooksEngineerIdStart,
  getAllUsersStart,
  getUserByCustomerIdStart,
  getUserByCurrentCustomerIdStart,
  getUserBySelectedCustomerIdStart,
  setReducerError,
  setCurrentCustomerUsers,
  setSelectedCustomerUsers,
  setAllUsers,
  setQuickBooksEngineer,
  setUser,
  setArchivedCustomerUsers,
  setUserProfile,
  setNewUser,
  setDeletedUser,
  setToggleModal,
  setImportNewUser,
  setResetUser,
  getUserByCurrentCustomerIdStop,
  setCurrentCustomerSecurityUsers,
  setCurrentCustomerNetworkingUsers,
} = userSlice.actions;

export default userSlice.reducer;
